import script from "./SchemaTrainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaTrainer.vue?vue&type=script&setup=true&lang=js"

import "./SchemaTrainer.vue?vue&type=style&index=0&id=634f6b61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-634f6b61"]])

export default __exports__